import script from "./agents-table.linux.vue?vue&type=script&setup=true&lang=ts"
export * from "./agents-table.linux.vue?vue&type=script&setup=true&lang=ts"

import "./agents-table.linux.vue?vue&type=style&index=0&id=2e2e34c4&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e2e34c4"]])

export default __exports__